import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, DropdownMenuSeparator, DropdownMenuLabel } from "@/components/ui/dropdown-menu";
import { Download, FileText, FileSpreadsheet, ChevronDown } from "lucide-react";
import { downloadExcel, printFull, printSummary } from "@/lib/exporters";

export function Downloads({ report }) {
  const title = `Asia-Australia Briefing — ${report.period || ""}`.trim();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="downloads-button"
          className="no-print flex items-center gap-2 bg-primary text-white rounded-lg px-4 h-10 text-sm font-medium hover:bg-primary/90 transition-colors"
        >
          <Download className="w-4 h-4" /> Download <ChevronDown className="w-4 h-4 opacity-80" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-60">
        <DropdownMenuLabel>Export this edition</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem data-testid="download-full-pdf" onClick={() => printFull(title)}>
          <FileText className="w-4 h-4 mr-2 text-primary" /> Full report (PDF)
        </DropdownMenuItem>
        <DropdownMenuItem data-testid="download-summary-pdf" onClick={() => printSummary(`${title} — Summary`)}>
          <FileText className="w-4 h-4 mr-2 text-accent" /> Executive summary (PDF)
        </DropdownMenuItem>
        <DropdownMenuItem data-testid="download-excel" onClick={() => downloadExcel(report)}>
          <FileSpreadsheet className="w-4 h-4 mr-2 text-emerald-600" /> All chart data (Excel)
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
